// React Dependencies
import React, { forwardRef } from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import apiService from '../../../services.js/apiService';
import SuggestionField from './SuggestionField';

const PageSuggestionField = forwardRef(({ disabled, value, onChange, apiParams = {} }, ref) => (
  <SuggestionField
    ref={ref}
    fetchSuggestions={apiService.getPagesSuggest}
    placeholder="Select page"
    disabled={disabled}
    value={value}
    onChange={onChange}
    apiParams={apiParams}
  />
));

PageSuggestionField.propTypes = {
  disabled: PropTypes.bool,
  value:    PropTypes.shape({
    id:   PropTypes.string,
    name: PropTypes.string,
  }),
  onChange:  PropTypes.func.isRequired,
  apiParams: PropTypes.shape({}),
};

PageSuggestionField.defaultProps = {
  disabled:  false,
  value:     null,
  apiParams: {},
};

export default PageSuggestionField;
